/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/th';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "เข้าไปยัง HTML Editor ที่สวยงาม"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "ระบบตรวจสอบการใช้งาน"
  },
  "action_to_take_b626a99a": {
    "message": "การดำเนินการที่จะมีขึ้น:"
  },
  "add_8523c19b": {
    "message": "เพิ่ม"
  },
  "add_a_caption_2a915239": {
    "message": "เพิ่มคำบรรยาย"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "เพิ่มข้อความเผื่อเลือกสำหรับภาพ"
  },
  "add_another_f4e50d57": {
    "message": "เพิ่มรายการอื่น"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "เพิ่ม CC/คำบรรยาย"
  },
  "add_image_60b2de07": {
    "message": "เพิ่มภาพ"
  },
  "add_one_9e34a6f8": {
    "message": "เพิ่มหนึ่งรายการ!"
  },
  "additional_considerations_f3801683": {
    "message": "ข้อพิจารณาเพิ่มเติม"
  },
  "address_applied_64269b0b": {
    "message": "ปรับใช้ที่อยู่แล้ว"
  },
  "address_removed_fcb496e0": {
    "message": "ลบที่อยู่แล้ว"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "ลิงค์ที่ติดกันกับ URL เหมือน ๆ กันควรเป็นลิงค์แยกเดี่ยว"
  },
  "aleph_f4ffd155": {
    "message": "อาเลฟ"
  },
  "align_11050992": {
    "message": "เชื่อมโยง"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "การจัดตำแหน่งและรายการต่าง ๆ"
  },
  "all_4321c3a1": {
    "message": "ทั้งหมด"
  },
  "all_apps_a50dea49": {
    "message": "แอพทั้งหมด"
  },
  "allow_media_download_16dcf2bd": {
    "message": "อนุญาตให้ดาวน์โหลดมีเดีย"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "อนุญาตให้ดาวน์โหลดทรานสคริปต์"
  },
  "alpha_15d59033": {
    "message": "อัลฟ่า"
  },
  "alphabetical_55b5b4e0": {
    "message": "ตามลำดับตัวอักษร"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "ข้อความคุณลักษณะเผื่อเลือกไม่ควรยาวเกินกว่า 120 ตัวอักษร"
  },
  "alt_text_611fb322": {
    "message": "ข้อความเผื่อเลือก"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Coproduct)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "เกิดข้อผิดพลาดขณะอ่านไฟล์"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "เกิดข้อผิดพลาดขณะทำคำขอผ่านเครือข่าย"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "เกิดข้อผิดพลาดขณะอัพโหลดสื่อของคุณ"
  },
  "and_7fcc2911": {
    "message": "และ"
  },
  "angle_c5b4ec50": {
    "message": "มุม"
  },
  "announcement_fb4cb645": {
    "message": "ประกาศ"
  },
  "announcement_list_da155734": {
    "message": "รายการประกาศ"
  },
  "announcements_a4b8ed4a": {
    "message": "ประกาศ"
  },
  "apply_781a2546": {
    "message": "ปรับใช้"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "ปรับใช้การเปลี่ยนแปลงกับส่วนรายการทั้งหมดของไอคอน Icon Maker (Icon Maker Icon) ในบทเรียน (Course) นี้"
  },
  "approaches_the_limit_893aeec9": {
    "message": "กำลังจะถึงเกณฑ์ที่จำกัดไว้"
  },
  "approximately_e7965800": {
    "message": "โดยประมาณ"
  },
  "apps_54d24a47": {
    "message": "แอพ"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "คุณแน่ใจว่าต้องการยกเลิกหรือไม่ การเปลี่ยนแปลงที่คุณทำขึ้นอาจไม่ถูกบันทึกไว้"
  },
  "arrows_464a3e54": {
    "message": "ลูกศร"
  },
  "art_icon_8e1daad": {
    "message": "ไอคอนอาร์ตเวิร์ค"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "สัดส่วนจะถูกรักษาไว้ตามเดิม"
  },
  "assignment_976578a8": {
    "message": "ภารกิจ"
  },
  "assignments_1e02582c": {
    "message": "ภารกิจ"
  },
  "asterisk_82255584": {
    "message": "ดอกจัน"
  },
  "attributes_963ba262": {
    "message": "คุณลักษณะ"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "ไม่รองรับบันทึกเสียงและภาพ กรุณาใช้เบราเซอร์อื่น"
  },
  "audio_options_feb58e2c": {
    "message": "ตัวเลือกเสียง"
  },
  "audio_options_tray_33a90711": {
    "message": "ถาดตัวเลือกเสียง"
  },
  "audio_player_for_title_20cc70d": {
    "message": "เครื่องเล่นเสียงสำหรับ { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "มีเนื้อหาบันทึกอัตโนมัติ ต้องการโหลดเนื้อหาบันทึกอัตโนมัติแทนหรือไม่"
  },
  "available_folders_694d0436": {
    "message": "โฟลเดอร์ที่ใช้ได้"
  },
  "background_1bc88842": {
    "message": "พื้นหลัง"
  },
  "backslash_b2d5442d": {
    "message": "แบ็คสแลช"
  },
  "bar_ec63ed6": {
    "message": "แท่ง"
  },
  "basic_554cdc0a": {
    "message": "พื้นฐาน"
  },
  "because_501841b": {
    "message": "เนื่องจาก"
  },
  "below_81d4dceb": {
    "message": "ด้านล่าง"
  },
  "beta_cb5f307e": {
    "message": "เบต้า"
  },
  "big_circle_16b2e604": {
    "message": "วงกลมใหญ่"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "สัมประสิทธิ์ทวินาม"
  },
  "black_4cb01371": {
    "message": "ดำ"
  },
  "blue_daf8fea9": {
    "message": "น้ำเงิน"
  },
  "bold_applied_42d547b7": {
    "message": "ปรับใช้ตัวหนาแล้ว"
  },
  "bold_removed_da474a5c": {
    "message": "ลบตัวหนาแล้ว"
  },
  "border_5b08b06d": {
    "message": "ขอบ"
  },
  "bottom_15a2a9be": {
    "message": "ล่างสุด"
  },
  "bottom_third_5f5fec1d": {
    "message": "อันดับที่สามจากด้านล่าง"
  },
  "bowtie_5f9629e4": {
    "message": "โบว์"
  },
  "brick_f2656265": {
    "message": "บริค"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "ยกเลิก"
  },
  "cap_product_3a5265a6": {
    "message": "ผล Cap"
  },
  "caption_manager_aae0906f": {
    "message": "เครื่องมือจัดการคำบรรยาย"
  },
  "center_align_e68d9997": {
    "message": "จัดกลาง"
  },
  "centered_dot_64d5e378": {
    "message": "จุดตรงกลาง"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "จุดแนวนอนตรงกลาง"
  },
  "change_alt_text_92654906": {
    "message": "เปลี่ยนข้อความเผื่อเลือก"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "เปลี่ยนหมายเหตุกำกับหัวเรื่องสำหรับย่อหน้า"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "เปลี่ยนเฉพาะระดับหัวเรื่องนี้"
  },
  "change_text_color_1aecb912": {
    "message": "เปลี่ยนสีข้อความ"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "การเปลี่ยนแปลงจะมีผลหลังจากบันทึกเพจนี้"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "การเปลี่ยนแปลงที่คุณทำขึ้นอาจไม่ถูกบันทึกไว้"
  },
  "characters_9d897d1c": {
    "message": "ตัวอักษร"
  },
  "characters_no_spaces_485e5367": {
    "message": "ตัวอักษร (ไม่มีเคาะว่าง)"
  },
  "check_accessibility_3c78211c": {
    "message": "ตรวจสอบการใช้งาน"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "กำลังตรวจสอบปัญหาการใช้งาน"
  },
  "chi_54a32644": {
    "message": "ชี่"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "เลือกไฟล์คำบรรยาย"
  },
  "choose_usage_rights_33683854": {
    "message": "เลือกสิทธิ์การใช้งาน..."
  },
  "circle_484abe63": {
    "message": "วงกลม"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "วงเลือกรายการที่ไม่ได้จัดลำดับ"
  },
  "clear_2084585f": {
    "message": "ล้าง"
  },
  "clear_image_3213fe62": {
    "message": "ล้างภาพ"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "คลิกหรือ shift-คลิก สำหรับ HTML Editor"
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "คลิกเพื่อผนวก { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "คลิกเพื่อซ่อนการแสดงตัวอย่าง"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "คลิกเพื่อแทรกลิงค์ไปยังโปรแกรมแก้ไข"
  },
  "click_to_show_preview_faa27051": {
    "message": "คลิกเพื่อแสดงตัวอย่าง"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "ปิดเมนูหรือกล่องโต้ตอบ และนำคุณกลับไปที่โปรแกรมแก้ไข"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "ปิดระบบตรวจสอบการใช้งาน"
  },
  "close_d634289d": {
    "message": "ปิด"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "ปิดโมดัลแป้นพิมพ์ลัด"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "ไฟล์คำบรรยายแบบปิดได้จะต้องมีขนาดน้อยกว่า { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "คำบรรยายแบบซ่อนได้"
  },
  "clubs_suit_c1ffedff": {
    "message": "คลับ (ชุด)"
  },
  "collab_575ac7bc": {
    "message": "ร่วมมือ"
  },
  "collaborations_5c56c15f": {
    "message": "การประสานความร่วมมือ"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "ย่อเพื่อซ่อน { types }"
  },
  "color_a363e1b0": {
    "message": "สี"
  },
  "color_contrast_4c418add": {
    "message": "ความต่างสี"
  },
  "color_contrast_ratio_687782f0": {
    "message": "สัดส่วนความต่างสี"
  },
  "color_picker_6b359edf": {
    "message": "ระบบเลือกสี "
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "ระบบเลือกสี ({ colorName } ที่เลือก)"
  },
  "color_popup_af39810f": {
    "message": "ป๊อปอัพสี"
  },
  "column_e1ae5c64": {
    "message": "คอลัมน์"
  },
  "column_group_1c062368": {
    "message": "กลุ่มคอลัมน์"
  },
  "complex_numbers_a543d004": {
    "message": "จำนวนเชิงซ้อน"
  },
  "computer_1d7dfa6f": {
    "message": "คอมพิวเตอร์"
  },
  "congruent_5a244acd": {
    "message": "สอดคล้อง"
  },
  "contains_311f37b7": {
    "message": "ประกอบด้วย"
  },
  "content_1440204b": {
    "message": "ข้อมูล"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "เนื้อหาในโปรแกรมแก้ไขจะมีการเปลี่ยนแปลง กด ยกเลิก (Cancel) เพื่อเก็บเนื้อหาเดิมไว้"
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "เนื้อหายังอัพโหลดอยู่ หากคุณดำเนินการต่อ ข้อมูลจะไม่ถูกผนวกอย่างถูกต้อง"
  },
  "content_subtype_5ce35e88": {
    "message": "ประเภทเนื้อหาย่อย"
  },
  "content_type_2cf90d95": {
    "message": "ประเภทเนื้อหา"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "ไปยังเนื้อหาจาก YouTube ของคุณต่อไป"
  },
  "coproduct_e7838082": {
    "message": "Coproduct"
  },
  "copyright_holder_66ee111": {
    "message": "ผู้ถือลิขสิทธิ์:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "ไม่สามารถแทรกเนื้อหา: \"{ itemType }\" ปัจจุบันไม่รองรับใน Canvas"
  },
  "count_40eced3b": {
    "message": "จำนวน"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 คำ}\n    one {1 คำ}\n  other {# คำ}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# รายการที่โหลด}\n  other {# รายการที่โหลด}\n}"
  },
  "course_documents_104d76e0": {
    "message": "เอกสารสำหรับบทเรียน"
  },
  "course_files_62deb8f8": {
    "message": "ไฟล์บทเรียน"
  },
  "course_files_a31f97fc": {
    "message": "ไฟล์บทเรียน"
  },
  "course_images_f8511d04": {
    "message": "ภาพในบทเรียน"
  },
  "course_link_b369426": {
    "message": "ลิงค์บทเรียน"
  },
  "course_links_b56959b9": {
    "message": "ลิงค์บทเรียน"
  },
  "course_media_ec759ad": {
    "message": "สื่อสำหรับบทเรียน"
  },
  "course_navigation_dd035109": {
    "message": "การสืบค้นเนื้อหาบทเรียน"
  },
  "create_icon_110d6463": {
    "message": "จัดทำไอคอน"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "จัดทำไอคอน Icon Maker"
  },
  "creative_commons_license_725584ae": {
    "message": "สิทธิ์ใช้งาน Creative Commons:"
  },
  "crop_image_41bf940c": {
    "message": "ครอปภาพ"
  },
  "crop_image_807ebb08": {
    "message": "ครอปภาพ"
  },
  "cup_product_14174434": {
    "message": "ผล Cup"
  },
  "current_image_f16c249c": {
    "message": "ภาพปัจจุบัน"
  },
  "current_link_945a47ee": {
    "message": "ลิงค์ปัจจุบัน"
  },
  "current_volume_level_c55ab825": {
    "message": "ระดับเสียงในปัจจุบัน"
  },
  "custom_6979cd81": {
    "message": "กำหนดเอง"
  },
  "cyan_c1d5f68a": {
    "message": "ฟ้า"
  },
  "dagger_57e0f4e5": {
    "message": "กริช"
  },
  "date_added_ed5ad465": {
    "message": "วันที่ที่เพิ่ม"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "ไอคอนตกแต่ง"
  },
  "decorative_image_fde98579": {
    "message": "ภาพตกแต่ง"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "{ TYPE_UPPER } สำหรับตกแต่ง"
  },
  "decrease_indent_d9cf469d": {
    "message": "ลดการเยื้อง"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "ลดพื้นที่ Rich Content"
  },
  "deep_purple_bb3e2907": {
    "message": "ม่วงเข้ม"
  },
  "default_9db103d": {
    "message": "ค่าเริ่มต้น"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "รายการที่ไม่ได้จัดลำดับแบบมีหัวข้อย่อยเริ่มต้น"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "รายการที่จัดลำดับแบบมีตัวเลขกำกับเริ่มต้น"
  },
  "definite_integral_fe7ffed1": {
    "message": "อินทริกรัลจำกัดเขต"
  },
  "degree_symbol_4a823d5f": {
    "message": "สัญลักษณ์องศา"
  },
  "delimiters_4db4840d": {
    "message": "ตัวคั่น"
  },
  "delta_53765780": {
    "message": "เดลต้า"
  },
  "describe_the_icon_f6a18823": {
    "message": "(ระบุรายละเอียดไอคอน)"
  },
  "describe_the_type_ff448da5": {
    "message": "(ระบุรายละเอียด { TYPE })"
  },
  "description_436c48d7": {
    "message": "รายละเอียด"
  },
  "details_98a31b68": {
    "message": "รายละเอียด"
  },
  "diagonal_dots_7d71b57e": {
    "message": "จุดแนวทแยง"
  },
  "diamond_b8dfe7ae": {
    "message": "เพชร"
  },
  "diamonds_suit_526abaaf": {
    "message": "ข้าวหลามตัด (ชุด)"
  },
  "digamma_258ade94": {
    "message": "ไดแกมม่า"
  },
  "dimension_type_f5fa9170": {
    "message": "ประเภทขนาด"
  },
  "directionality_26ae9e08": {
    "message": "ทิศทาง"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "แก้ไข LaTeX โดยตรง"
  },
  "disable_preview_222bdf72": {
    "message": "ปิดใช้งานการแสดงตัวอย่าง"
  },
  "discussion_6719c51d": {
    "message": "การพูดคุย"
  },
  "discussions_a5f96392": {
    "message": "การพูดคุย"
  },
  "discussions_index_6c36ced": {
    "message": "ดัชนีการพูดคุย"
  },
  "disjoint_union_e74351a8": {
    "message": "ยูเนียนที่ไม่เกี่ยวพันกัน"
  },
  "display_options_315aba85": {
    "message": "แสดงตัวเลือก"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "แสดงลิงค์ข้อความ (เปิดในแท็บใหม่)"
  },
  "div_applied_49ad83fc": {
    "message": "ปรับใช้ Div แล้ว"
  },
  "div_removed_d13f8e17": {
    "message": "ลบ Div แล้ว"
  },
  "division_sign_72190870": {
    "message": "สัญลักษณ์หาร"
  },
  "document_678cd7bf": {
    "message": "เอกสาร"
  },
  "documents_81393201": {
    "message": "เอกสาร"
  },
  "done_54e3d4b6": {
    "message": "เสร็จสิ้น"
  },
  "double_dagger_faf78681": {
    "message": "กริชคู่"
  },
  "down_5831a426": {
    "message": "ลง"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "ลูกศรลงและทแยงซ้าย"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "ลูกศรลงและทแยงขวา"
  },
  "download_filename_2baae924": {
    "message": "ดาวน์โหลด { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "ลูกศรลง"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "สามเหลี่ยมชี้ลง"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "ลากไฟล์ที่นี่"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "ลากและวาง หรือคลิกเพื่อเรียกดูในคอมพิวเตอร์ของคุณ"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "ลากที่มือจับ ใช้ลูกศรขึ้นและลงเพื่อปรับขนาด"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "ครบกำหนด: วันที่หลายรายการ"
  },
  "due_when_7eed10c6": {
    "message": "ครบกำหนด: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "แก้ไขข้อความเผื่อเลือกในรายการไอคอนนี้"
  },
  "edit_c5fbea07": {
    "message": "แก้ไข"
  },
  "edit_course_link_5a5c3c59": {
    "message": "แก้ไขลิงค์บทเรียน"
  },
  "edit_equation_f5279959": {
    "message": "แก้ไขสมการ"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "แก้ไข ไอคอนในปัจจุบัน Maker Icon"
  },
  "edit_icon_2c6b0e91": {
    "message": "ไอคอนแก้ไข"
  },
  "edit_link_7f53bebb": {
    "message": "แก้ไขลิงค์"
  },
  "editor_status_bar_653f44ee": {
    "message": "แถบสถานะโปรแกรมแก้ไข"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "องค์ประกอบเริ่มต้นด้วย { start }"
  },
  "embed_828fac4a": {
    "message": "ผนวก"
  },
  "embed_code_314f1bd5": {
    "message": "ผนวกรหัส"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "แทรกเนื้อหาจากเครื่องมือจากภายนอก"
  },
  "embed_image_1080badc": {
    "message": "ผนวกภาพ"
  },
  "embed_video_a97a64af": {
    "message": "ผนวกวิดีโอ"
  },
  "embedded_content_aaeb4d3d": {
    "message": "เนื้อหาที่ผนวก"
  },
  "empty_set_91a92df4": {
    "message": "ชุดว่างเปล่า"
  },
  "encircled_dot_8f5e51c": {
    "message": "จุดวงกลมล้อมรอบ"
  },
  "encircled_minus_72745096": {
    "message": "เครื่องหมายลบวงกลมล้อมรอบ"
  },
  "encircled_plus_36d8d104": {
    "message": "เครื่องหมายบวกวงกลมล้อมรอบ"
  },
  "encircled_times_5700096d": {
    "message": "เวลาวงกลมล้อมรอบ"
  },
  "engineering_icon_f8f3cf43": {
    "message": "ไอคอนวิศวกรรม"
  },
  "english_icon_25bfe845": {
    "message": "ไอคอนอังกฤษ"
  },
  "enter_a_media_title_81b490ec": {
    "message": "กรอกชื่อมีเดีย"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "กรอกอย่างน้อย 3 ตัวอักษรเพื่อค้นหา"
  },
  "enter_replacement_text_17631bbc": {
    "message": "กรอกข้อความแทนที่"
  },
  "enter_search_text_26cb4459": {
    "message": "กรอกข้อความค้นหา"
  },
  "epsilon_54bb8afa": {
    "message": "เอปไซลอน"
  },
  "epsilon_variant_d31f1e77": {
    "message": "เอปไซลอน (ตัวแปร)"
  },
  "equals_sign_c51bdc58": {
    "message": "สัญลักษณ์เท่ากับ"
  },
  "equation_1c5ac93c": {
    "message": "สมการ"
  },
  "equation_editor_39fbc3f1": {
    "message": "ตัวแก้ไขสมการ"
  },
  "equilibrium_6ff3040b": {
    "message": "ความสมดุล"
  },
  "equivalence_class_7b0f11c0": {
    "message": "ชั้นสมมูล"
  },
  "equivalent_identity_654b3ce5": {
    "message": "เทียบเท่า (ไอเดนติตี้)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "มีอยู่"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "ออกจากโหมดเต็มหน้าจอ"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "ขยายตัวอย่างเป็นค่าเริ่มต้น"
  },
  "expand_to_see_types_f5d29352": {
    "message": "ขยายเพื่อดู { types }"
  },
  "external_link_d3f9e62a": {
    "message": "ลิงค์จากภายนอก"
  },
  "external_tool_frame_70b32473": {
    "message": "กรอบเครื่องมือจากภายนอก"
  },
  "external_tools_6e77821": {
    "message": "เครื่องมือจากภายนอก"
  },
  "extra_large_b6cdf1ff": {
    "message": "ใหญ่พิเศษ"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "ใหญ่พิเศษ ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "เล็กพิเศษ"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "ไอคอนกิจกรรมนอกหลักสูตร"
  },
  "f_function_fe422d65": {
    "message": "F (ฟังก์ชั่น)"
  },
  "fail_544e5dde": {
    "message": "ล้มเหลว"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "ไม่สามารถสืบค้นเนื้อหาของไฟล์"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "ไม่สามารถเรียกค้นเนื้อหาจากเครื่องมือภายนอก"
  },
  "file_name_8fd421ff": {
    "message": "ชื่อไฟล์"
  },
  "file_preview_21667a6e": {
    "message": "แสดงตัวอย่างไฟล์"
  },
  "file_preview_for_filename_ab314195": {
    "message": "แสดงตัวอย่างไฟล์สำหรับ { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "เกินโควต้าพื้นที่จัดเก็บไฟล์"
  },
  "file_url_c12b64be": {
    "message": "URL ไฟล์"
  },
  "filename_file_icon_602eb5de": {
    "message": "ไอคอนไฟล์ { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "แสดงตัวอย่างภาพ { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "แสดงตัวอย่างข้อความ { filename }"
  },
  "files_c300e900": {
    "message": "ไฟล์"
  },
  "files_index_af7c662b": {
    "message": "ดัชนีไฟล์"
  },
  "find_8d605019": {
    "message": "ค้นหา"
  },
  "find_and_replace_6e345933": {
    "message": "ค้นหาและแทนที่"
  },
  "finish_bc343002": {
    "message": "เสร็จสิ้น"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "แก้ไขโครงสร้างหัวเรื่อง"
  },
  "flat_music_76d5a5c3": {
    "message": "แฟลท (ดนตรี)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "ปรับโฟกัสแถบเครื่องมือตัวเลือกส่วนประกอบ"
  },
  "folder_tree_fbab0726": {
    "message": "โครงสร้างโฟลเดอร์"
  },
  "for_all_b919f972": {
    "message": "สำหรับทั้งหมด"
  },
  "format_4247a9c5": {
    "message": "รูปแบบ"
  },
  "format_as_a_list_142210c3": {
    "message": "กำหนดรูปแบบเป็นรายการ"
  },
  "formatting_5b143aa8": {
    "message": "การกำหนดรูปแบบ"
  },
  "forward_slash_3f90f35e": {
    "message": "ฟอร์วอร์ดสแลช"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "พบเนื้อหาบันทึกอัตโนมัติ"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "พบ { count, plural,\n     =0 {# ผลลัพธ์}\n    one {# ผลลัพธ์}\n  other {# ผลลัพธ์}\n}"
  },
  "fraction_41bac7af": {
    "message": "สัดส่วน"
  },
  "fullscreen_873bf53f": {
    "message": "เต็มหน้าจอ"
  },
  "gamma_1767928": {
    "message": "แกมม่า"
  },
  "generating_preview_45b53be0": {
    "message": "กำลังจัดทำตัวอย่างจัดแสดง..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "ฟอร์แมตภาพ GIF/PNG ขนาดใหญ่กว่า { size } KB ยังไม่รองรับในปัจจุบัน"
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "ไปที่แถบเมนูของโปรแกรมแก้ไข"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "ไปที่แถบเครื่องมือของโปรแกรมแก้ไข"
  },
  "grades_a61eba0a": {
    "message": "เกรด"
  },
  "graphics_text_bc9568bc": {
    "message": "ข้อความกราฟิก"
  },
  "greater_than_e98af662": {
    "message": "มากกว่า"
  },
  "greater_than_or_equal_b911949a": {
    "message": "มากกว่าหรือเท่ากับ"
  },
  "greek_65c5b3f7": {
    "message": "กรีก"
  },
  "green_15af4778": {
    "message": "เขียว"
  },
  "grey_a55dceff": {
    "message": "เทา"
  },
  "group_documents_8bfd6ae6": {
    "message": "เอกสารของกลุ่ม"
  },
  "group_files_4324f3df": {
    "message": "ไฟล์ของกลุ่ม"
  },
  "group_files_82e5dcdb": {
    "message": "ไฟล์ของกลุ่ม"
  },
  "group_images_98e0ac17": {
    "message": "ภาพกลุ่ม"
  },
  "group_isomorphism_45b1458c": {
    "message": "ไอโซมอร์ฟิกของกลุ่ม"
  },
  "group_link_63e626b3": {
    "message": "ลิงค์ของกลุ่ม"
  },
  "group_links_9493129e": {
    "message": "ลิงค์ของกลุ่ม"
  },
  "group_media_2f3d128a": {
    "message": "สื่อของกลุ่ม"
  },
  "group_navigation_99f191a": {
    "message": "การสืบค้นเนื้อหาของกลุ่ม"
  },
  "h_bar_bb94deae": {
    "message": "แท่ง H"
  },
  "hat_ea321e35": {
    "message": "หมวก"
  },
  "header_column_f27433cb": {
    "message": "คอลัมน์หัวเรื่อง"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "แถวและคอลัมน์หัวเรื่อง"
  },
  "header_row_f33eb169": {
    "message": "แถวหัวเรื่อง"
  },
  "heading_2_5b84eed2": {
    "message": "หัวเรื่อง 2"
  },
  "heading_3_2c83de44": {
    "message": "หัวเรื่อง 3"
  },
  "heading_4_b2e74be7": {
    "message": "หัวเรื่อง 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "ปรับใช้หัวเรื่อง { h } แล้ว"
  },
  "heading_h_removed_745f24a6": {
    "message": "ลบหัวเรื่อง { h } แล้ว"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "ไม่ควรข้ามระดับหัวเรื่อง"
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "หัวเรื่องเริ่มต้นด้วย { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "หัวเรื่องไม่ควรยาวมากกว่า 120 ตัวอักษร"
  },
  "health_icon_8d292eb5": {
    "message": "ไอคอนสุขภาพ"
  },
  "hearts_suit_e50e04ca": {
    "message": "หัวใจ (ชุด)"
  },
  "height_69b03e15": {
    "message": "ความสูง"
  },
  "hexagon_d8468e0d": {
    "message": "หกเหลี่ยม"
  },
  "hide_description_bfb5502e": {
    "message": "ซ่อนรายละเอียด"
  },
  "hide_title_description_caf092ef": {
    "message": "ซ่อนรายละเอียด { title }"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "แรเงาองค์ประกอบเพื่อเปิดใช้แถบเครื่องมือตัวเลือกองค์ประกอบ"
  },
  "home_351838cd": {
    "message": "หน้าหลัก"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "จะแจ้งขอและแก้ไขคำบรรยายได้อย่างไร"
  },
  "html_code_editor_fd967a44": {
    "message": "โปรแกรมแก้ไขรหัส HTML"
  },
  "html_editor_fb2ab713": {
    "message": "HTML Editor"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "ฉันได้รับสิทธิ์อนุญาตให้ใช้ไฟล์นี้"
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "ฉันถือลิขสิทธิ์"
  },
  "icon_215a1dc6": {
    "message": "ไอคอน"
  },
  "icon_8168b2f8": {
    "message": "ไอคอน"
  },
  "icon_color_b86dd6d6": {
    "message": "สีไอคอน"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "ไอคอน Icon Maker"
  },
  "icon_options_7e32746e": {
    "message": "ตัวเลือกไอคอน"
  },
  "icon_options_tray_2b407977": {
    "message": "ถาดตัวเลือกไอคอน"
  },
  "icon_preview_1782a1d9": {
    "message": "แสดงตัวอย่างไอคอน"
  },
  "icon_shape_30b61e7": {
    "message": "รูปทรงไอคอน"
  },
  "icon_size_9353edea": {
    "message": "ขนาดไอคอน"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "หากปล่อยลิงค์ว่างไว้ ข้อความจะปรากฏเป็นชื่อลิงค์บทเรียน"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "หากต้องมีสิทธิ์การใช้งาน (Usage Rights) ไฟล์จะไม่ถูกเผยแพร่จนกว่าจะเปิดใช้งานในเพจไฟล์ (Files)"
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "หากคุณไม่เลือกสิทธิ์การใช้งาน ไฟล์นี้จะถูกเลิกเผยแพร่หลังจากอัพโหลดแล้ว"
  },
  "image_8ad06": {
    "message": "ภาพ"
  },
  "image_c1c98202": {
    "message": "ภาพ"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "ชื่อไฟล์ภาพไม่ควรใช้เป็นคุณลักษณะเผื่อเลือกเพื่อระบุเนื้อหาในภาพ"
  },
  "image_options_5412d02c": {
    "message": "ตัวเลือกภาพ"
  },
  "image_options_tray_90a46006": {
    "message": "ถาดตัวเลือกภาพ"
  },
  "image_to_crop_3a34487d": {
    "message": "ภาพที่จะครอป"
  },
  "image_with_filename_file_aacd7180": {
    "message": "ภาพพร้อมชื่อไฟล์ { file }"
  },
  "images_7ce26570": {
    "message": "ภาพ"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "ภาพควรมีคุณลักษณะเผื่อเลือกระบุเนื้อหาของภาพ"
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "สัดส่วนจินตภาพ (ของจำนวนเชิงซ้อน)"
  },
  "in_element_of_19ca2f33": {
    "message": "ใน (องค์ประกอบของ)"
  },
  "increase_indent_6af90f7c": {
    "message": "เพิ่มการเยื้อง"
  },
  "increase_rich_content_area_340b775": {
    "message": "เพิ่มพื้นที่ Rich Content"
  },
  "indefinite_integral_6623307e": {
    "message": "อินทริกรัลไม่จำกัดเขต"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } จาก { max }"
  },
  "indigo_2035fc55": {
    "message": "คราม"
  },
  "inference_fed5c960": {
    "message": "การอนุมาน"
  },
  "infinity_7a10f206": {
    "message": "อนันต์"
  },
  "input_field_for_alpha_678265fd": {
    "message": "ฟิลด์ป้อนข้อมูลสำหรับอัลฟ่า"
  },
  "input_field_for_blue_561e020a": {
    "message": "ฟิลด์ป้อนข้อมูลสำหรับสีน้ำเงิน"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "ฟิลด์ป้อนข้อมูลสำหรับสีเขียว"
  },
  "input_field_for_red_86a84615": {
    "message": "ฟิลด์ป้อนข้อมูลสำหรับสีแดง"
  },
  "insert_593145ef": {
    "message": "ใบกัด"
  },
  "insert_link_6dc23cae": {
    "message": "แทรกลิงค์"
  },
  "insert_math_equation_57c6e767": {
    "message": "แทรกสมการทางคณิตศาสตร์"
  },
  "integers_336344e1": {
    "message": "จำนวนเต็ม"
  },
  "intersection_cd4590e4": {
    "message": "ตัดกัน"
  },
  "invalid_description_991e23bb": {
    "message": "รายละเอียดไม่ถูกต้อง"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "รายการไม่ถูกต้อง"
  },
  "invalid_file_c11ba11": {
    "message": "ไฟล์ไม่ถูกต้อง"
  },
  "invalid_file_type_881cc9b2": {
    "message": "ประเภทไฟล์ไม่ถูกต้อง"
  },
  "invalid_url_cbde79f": {
    "message": "URL ไม่ถูกต้อง"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "ประเด็น { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "ปรับใช้ตัวเอียงแล้ว"
  },
  "italic_removed_17cbab6f": {
    "message": "ลบตัวเอียงแล้ว"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (ตัวแปร)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "ชอร์ตคัทแป้นพิมพ์"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "แป้นพิมพ์สืบค้นลิงค์ต่าง ๆ โดยใช้ปุ่ม Tab ลิงค์สองตัวที่ติดกันที่นำไปยังปลายทางเดียวกันอาจทำให้ผู้ใช้แป้นพิมพ์เกิดความสับสน"
  },
  "lambda_4f602498": {
    "message": "แลมบ์ด้า"
  },
  "language_arts_icon_a798b0f8": {
    "message": "ไอคอนศิลปศาสตร์ด้านภาษา"
  },
  "languages_icon_9d20539": {
    "message": "ไอคอนภาษา"
  },
  "large_9c5e80e7": {
    "message": "ใหญ่"
  },
  "large_text_e7ba08cd": {
    "message": "ข้อความขนาดใหญ่"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "ใหญ่ ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "เรียนรู้"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "เรียนรู้เพิ่มเติมเกี่ยวกับลิงค์ที่ติดกัน"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "เรียนรู้เพิ่มเติมเกี่ยวกับคอนทราสต์สี"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "เรียนรู้เพิ่มเติมเกี่ยวกับการกำหนดโครงสร้างหัวเรื่องเพจ"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "เรียนรู้เพิ่มเติมเกี่ยวกับโครงสร้างหัวเรื่องหน้าเพจที่เหมาะสม"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "เรียนรู้เพิ่มเติมเกี่ยวกับหัวตาราง"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "เรียนรู้เพิ่มเติมเกี่ยวกับการใช้ข้อความสำรองสำหรับภาพ"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "เรียนรู้เพิ่มเติมเกี่ยวกับการใช้คำบรรยายกับตาราง"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "เรียนรู้เพิ่มเติมเกี่ยวกับการใช้ชื่อไฟล์เป็นข้อความเผื่อเลือก"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "เรียนรู้เพิ่มเติมเกี่ยวกับการใช้รายการ"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "เรียนรู้เพิ่มเติมเกี่ยวกับการใช้คุณลักษณะขอบเขตกับตาราง"
  },
  "leave_as_is_4facfe55": {
    "message": "ปล่อยไว้ตามเดิม"
  },
  "left_3ea9d375": {
    "message": "ซ้าย"
  },
  "left_align_43d95491": {
    "message": "จัดซ้าย"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "วงเล็บมุมซ้าย"
  },
  "left_arrow_4fde1a64": {
    "message": "ลูกศรซ้าย"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "ลูกศรซ้ายพร้อมขอเกี่ยว"
  },
  "left_ceiling_ee9dd88a": {
    "message": "บนซ้าย"
  },
  "left_curly_brace_1726fb4": {
    "message": "ปีกกาซ้าย"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "ลูกศรฉมวกล่างซ้าย"
  },
  "left_floor_29ac2274": {
    "message": "ล่างซ้าย"
  },
  "left_to_right_e9b4fd06": {
    "message": "ซ้ายไปขวา"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "ลูกศรฉมวกบนซ้าย"
  },
  "leftward_arrow_1e4765de": {
    "message": "ลูกศรซ้าย"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "สามเหลี่ยมชี้ซ้าย"
  },
  "less_than_a26c0641": {
    "message": "น้อยกว่า"
  },
  "less_than_or_equal_be5216cb": {
    "message": "น้อยกว่าหรือเท่ากับ"
  },
  "library_icon_ae1e54cf": {
    "message": "ไอคอนห้องสมุด"
  },
  "light_blue_5374f600": {
    "message": "ฟ้า"
  },
  "link_7262adec": {
    "message": "ลิงค์"
  },
  "link_options_a16b758b": {
    "message": "ตัวเลือกลิงค์"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "ประเภทลิงค์: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "ลิงค์ที่มีข้อความเริ่มต้นด้วย { start }"
  },
  "links_14b70841": {
    "message": "ลิงค์"
  },
  "links_to_an_external_site_de74145d": {
    "message": "ลิงค์ไปยังไซต์ภายนอก"
  },
  "lists_cd1336fc": {
    "message": "รายการ"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "รายการควรกำหนดรูปแบบเป็นแสดงรายการ"
  },
  "load_more_35d33c7": {
    "message": "โหลดเพิ่มเติม"
  },
  "loading_25990131": {
    "message": "กำลังโหลด..."
  },
  "loading_bde52856": {
    "message": "กำลังโหลด"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "โหลดคำบรรยายแบบซ่อนได้ล้มเหลว"
  },
  "loading_external_tool_d839042c": {
    "message": "กำลังโหลดเครื่องมือจากภายนอก"
  },
  "loading_failed_b3524381": {
    "message": "โหลดล้มเหลว..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "โหลดล้มเหลว..."
  },
  "loading_folders_d8b5869e": {
    "message": "กำลังโหลดโฟลเดอร์"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "กำลังโหลดตัวกำกับตำแหน่งสำหรับ { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "กำลังโหลด กรุณารอสักครู่"
  },
  "loading_preview_9f077aa1": {
    "message": "กำลังโหลดตัวอย่าง"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "ล็อความเร็วที่ 1x"
  },
  "locked_762f138b": {
    "message": "ล็อคแล้ว"
  },
  "logical_equivalence_76fca396": {
    "message": "สมมูลเชิงตรรกศาสตร์"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "สมมูลเชิงตรรกศาสตร์ (สั้น)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "สมมูลเชิงตรรกะศาสตร์ (สั้นและหนา)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "สมมูลเชิงตรรกศาสตร์ (หนา)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "จุดแนวนอนช่วงต่ำ"
  },
  "magenta_4a65993c": {
    "message": "ม่วงอมแดง"
  },
  "maps_to_e5ef7382": {
    "message": "แผนที่ไป"
  },
  "math_icon_ad4e9d03": {
    "message": "ไอคอนคณิตศาสตร์"
  },
  "media_af190855": {
    "message": "มีเดีย"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "ไฟล์มีเดียกำลังประมวลผล กรุณาลองใหม่อีกครั้งในภายหลัง"
  },
  "media_options_saved_560c4ec8": {
    "message": "บันทึกตัวเลือกมีเดียแล้ว"
  },
  "media_title_2112243b": {
    "message": "ชื่อสื่อ"
  },
  "medium_5a8e9ead": {
    "message": "ปานกลาง"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "ปานกลาง ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "ผสานลิงค์"
  },
  "mic_a7f3d311": {
    "message": "ไมโครโฟน"
  },
  "microphone_disabled_15c83130": {
    "message": "ไมโครโฟนปิดใช้งาน"
  },
  "middle_27dc1d5": {
    "message": "ตรงกลาง"
  },
  "minimize_file_preview_da911944": {
    "message": "ย่อการแสดงตัวอย่างไฟล์"
  },
  "minimize_video_20aa554b": {
    "message": "ย่อวิดีโอ"
  },
  "minus_fd961e2e": {
    "message": "ลบ"
  },
  "minus_plus_3461f637": {
    "message": "ลบ/บวก"
  },
  "misc_3b692ea7": {
    "message": "เบ็ดเตล็ด"
  },
  "miscellaneous_e9818229": {
    "message": "เบ็ดเตล็ด"
  },
  "module_90d9fd32": {
    "message": "หน่วยการเรียน"
  },
  "modules_c4325335": {
    "message": "หน่วยการเรียน"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "กำลังเคลื่อนย้ายภาพเพื่อครอป { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "ภาพหลายสี"
  },
  "multiplication_sign_15f95c22": {
    "message": "สัญลักษณ์คูณ"
  },
  "music_icon_4db5c972": {
    "message": "ไอคอนดนตรี"
  },
  "my_files_2f621040": {
    "message": "ไฟล์ของฉัน"
  },
  "n_th_root_9991a6e4": {
    "message": "รากที่ n"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "ชื่อ"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "ธรรมชาติ (ดนตรี)"
  },
  "natural_numbers_3da07060": {
    "message": "จำนวนธรรมชาติ"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "ดูรายการเมนูหรือแถบเครื่องมือ"
  },
  "navigation_ee9af92d": {
    "message": "การสืบค้น"
  },
  "nested_greater_than_d852e60d": {
    "message": "เชิงซ้อนมากกว่า"
  },
  "nested_less_than_27d17e58": {
    "message": "เชิงซ้อนน้อยกว่า"
  },
  "new_quiz_34aacba6": {
    "message": "แบบทดสอบใหม่"
  },
  "next_40e12421": {
    "message": "ถัดไป"
  },
  "next_findtext_9d69f0fe": {
    "message": "{ findText } ถัดไป"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "ไม่พบปัญหาในการใช้งาน"
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "ยังไม่ได้จัดทำประกาศ"
  },
  "no_announcements_found_20185afc": {
    "message": "ไม่พบประกาศ"
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "ยังไม่ได้จัดทำภารกิจ"
  },
  "no_assignments_found_79e46d7f": {
    "message": "ไม่พบภารกิจ"
  },
  "no_changes_to_save_d29f6e91": {
    "message": "ไม่มีการเปลี่ยนแปลงที่จะบันทึก"
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "ยังไม่ได้จัดทำส่วนการพูดคุย"
  },
  "no_discussions_found_9284063b": {
    "message": "ไม่พบส่วนการพูดคุย"
  },
  "no_e16d9132": {
    "message": "ไม่"
  },
  "no_file_chosen_9a880793": {
    "message": "ไม่มีไฟล์ที่เลือก"
  },
  "no_headers_9bc7dc7f": {
    "message": "ไม่มีหัวเรื่อง"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "ยังไม่ได้จัดทำหน่วยการเรียน"
  },
  "no_modules_found_2df43a40": {
    "message": "ไม่พบหน่วยการเรียน"
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "ยังไม่ได้จัดทำเพจ"
  },
  "no_pages_found_6799350": {
    "message": "ไม่พบเพจ"
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "ไม่มีตัวอย่างแสดงสำหรับไฟล์นี้"
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "ยังไม่ได้จัดทำแบบทดสอบ"
  },
  "no_quizzes_found_c80c537a": {
    "message": "ไม่พบแบบทดสอบ"
  },
  "no_results_940393cf": {
    "message": "ไม่มีผลลัพธ์"
  },
  "no_results_found_58717065": {
    "message": "ไม่พบผลลัพธ์"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "ไม่พบผลลัพธ์สำหรับ { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "ไม่มีวิดีโอ"
  },
  "none_3b5e34d2": {
    "message": "ไม่มี"
  },
  "none_selected_b93d56d2": {
    "message": "ไม่ได้เลือกรายการใด"
  },
  "normal_text_7b03da48": {
    "message": "ข้อความปกติ"
  },
  "not_equal_6e2980e6": {
    "message": "ไม่เท่ากับ"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "ไม่อยู่ใน (ไม่ใช่องค์ประกอบของ)"
  },
  "not_negation_1418ebb8": {
    "message": "ไม่ใช่ (นิเสธ)"
  },
  "not_subset_dc2b5e84": {
    "message": "ไม่ใช่ซับเซ็ต"
  },
  "not_subset_strict_23d282bf": {
    "message": "ไม่ใช่ซับเซ็ต (เข้มงวด)"
  },
  "not_superset_5556b913": {
    "message": "ไม่ใช่ซุปเปอร์เซ็ต"
  },
  "not_superset_strict_24e06f36": {
    "message": "ไม่ใช่ซุปเปอร์เซ็ต (เข้มงวด)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "แปดเหลี่ยม"
  },
  "olive_6a3e4d6b": {
    "message": "โอลีฟ"
  },
  "omega_8f2c3463": {
    "message": "โอเมก้า"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "จะต้องเพิ่มรูปแบบอย่างหนึ่งอย่างใดต่อไปนี้เพื่อบันทึกไอคอน: สีไอคอน (Icon Color) ขนาดกรอบ (Outline Size) ข้อความไอคอน (Icon Text) หรือภาพ (Image)"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "ไฟล์บางส่วนไม่สามารถวางได้ กรุณาลองอัพโหลดหรือลากและวางไฟล์"
  },
  "open_circle_e9bd069": {
    "message": "วงกลมกลวง"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "เปิดกล่องโต้ตอบชอร์ตคัทแป้นพิมพ์นี้"
  },
  "open_title_application_fd624fc5": {
    "message": "เปิดแอพพลิเคชั่น { title }"
  },
  "operators_a2ef9a93": {
    "message": "ผู้ดำเนินการ"
  },
  "options_3ab0ea65": {
    "message": "ตัวเลือก"
  },
  "or_9b70ccaa": {
    "message": "หรือ"
  },
  "orange_81386a62": {
    "message": "ส้ม"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "รายการที่จัดลำดับและไม่ได้จัดลำดับ"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "ชอร์ตคัทโปรแกรมแก้ไขอื่น ๆ สามารถค้นหาได้จาก"
  },
  "outline_color_3ef2cea7": {
    "message": "สีเค้าโครง"
  },
  "outline_size_a6059a21": {
    "message": "ขนาดเค้าโครง"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } ไม่ใช่โปรโตคอลที่ถูกต้อง"
  },
  "page_50c4823d": {
    "message": "หน้า"
  },
  "pages_e5414c2c": {
    "message": "เพจ"
  },
  "paragraph_5e5ad8eb": {
    "message": "ย่อหน้า"
  },
  "paragraph_applied_959b3fe5": {
    "message": "ปรับใช้ย่อหน้าแล้ว"
  },
  "paragraph_removed_d09320e": {
    "message": "ลบย่อหน้าแล้ว"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "ย่อหน้าที่เริ่มต้นด้วย { start }"
  },
  "parallel_d55d6e38": {
    "message": "คู่ขนาน"
  },
  "partial_derivative_4a9159df": {
    "message": "บางส่วน (อนุพันธ์)"
  },
  "pass_1c19a2b3": {
    "message": "ผ่าน"
  },
  "paste_5963d1c1": {
    "message": "วาง"
  },
  "pause_12af3bb4": {
    "message": "หยุดชั่วคราว"
  },
  "pentagon_17d82ea3": {
    "message": "ห้าเหลี่ยม"
  },
  "people_b4ebb13c": {
    "message": "บุคคล"
  },
  "percentage_34ab7c2c": {
    "message": "เปอร์เซ็นต์"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "เปอร์เซ็นต์จะต้องเป็นตัวเลข"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "เปอร์เซ็นต์อย่างน้อยจะต้องเท่ากับ { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "ไอคอนนาฏศิลป์"
  },
  "perpendicular_7c48ede4": {
    "message": "แนวดิ่ง"
  },
  "phi_4ac33b6d": {
    "message": "ฟาย"
  },
  "phi_variant_c9bb3ac5": {
    "message": "ฟาย (ตัวแปร)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "ไอคอนพลศึกษา"
  },
  "pi_dc4f0bd8": {
    "message": "พาย"
  },
  "pi_variant_10f5f520": {
    "message": "พาย (ตัวแปร)"
  },
  "pick_a_color_557abfb0": {
    "message": "เลือกสี"
  },
  "pink_68ad45cb": {
    "message": "ชมพู"
  },
  "pixels_52ece7d1": {
    "message": "พิกเซล"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "พิกเซลจะต้องอย่างน้อยเท่ากับ { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "เปิดเล่น"
  },
  "play_media_comment_35257210": {
    "message": "เปิดเล่นความเห็นแบบสื่อ"
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "เปิดเล่นความเห็นแบบสื่อโดย { name } จาก { createdAt }"
  },
  "player_layout_14e09a29": {
    "message": "เค้าโครงเครื่องเล่น"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "กรุณาให้อนุญาต Canvas ในการใช้งานไมโครโฟนและเว็บแคมของคุณ"
  },
  "please_choose_a_file_c2449cc": {
    "message": "กรุณาเลือกไฟล์"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "กรุณากรอกชื่อไฟล์"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "กรุณากรอก URL วิดีโอที่ถูกต้องจากแพลตฟอร์มที่รองรับ"
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "กรุณาเลือกประเภทไฟล์ที่รองรับ"
  },
  "plus_d43cd4ec": {
    "message": "บวก"
  },
  "plus_minus_f8be2e83": {
    "message": "บวก/ลบ"
  },
  "posted_when_a578f5ab": {
    "message": "โพสต์เมื่อ: { when }"
  },
  "power_set_4f26f316": {
    "message": "พาวเวอร์เซ็ต"
  },
  "precedes_196b9aef": {
    "message": "นำหน้า"
  },
  "precedes_equal_20701e84": {
    "message": "นำหน้าเท่ากับ"
  },
  "preformatted_d0670862": {
    "message": "กำหนดรูปแบบไว้ล่วงหน้า"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "ก่อนหน้า"
  },
  "preview_53003fd2": {
    "message": "แสดงตัวอย่าง"
  },
  "preview_a3f8f854": {
    "message": "แสดงตัวอย่าง"
  },
  "preview_in_overlay_ed772c46": {
    "message": "แสดงตัวอย่างเป็นโอเวอร์เลย์"
  },
  "preview_inline_9787330": {
    "message": "แสดงตัวอย่างในแถว"
  },
  "previous_bd2ac015": {
    "message": "ก่อนหน้า"
  },
  "previous_findtext_8dfbfd30": {
    "message": "{ findText } ก่อนหน้า"
  },
  "previously_chosen_colors_f1338315": {
    "message": "สีที่เลือกไว้ก่อนหน้า"
  },
  "prime_917ea60e": {
    "message": "เฉพาะ"
  },
  "prime_numbers_13464f61": {
    "message": "จำนวนเฉพาะ"
  },
  "product_39cf144f": {
    "message": "ผล"
  },
  "proportional_f02800cc": {
    "message": "ตามสัดส่วน"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "โปรโตคอลจะต้องเป็น ftp, http, https, mailto, skype, tel หรือสามารถเว้นว่าง"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "เผยแพร่แล้ว"
  },
  "published_when_302d8e23": {
    "message": "เผยแพร่แล้ว: { when }"
  },
  "pumpkin_904428d5": {
    "message": "ฟักทอง"
  },
  "purple_7678a9fc": {
    "message": "ม่วง"
  },
  "quaternions_877024e0": {
    "message": "ควอเทอร์เนียน"
  },
  "quiz_e0dcce8f": {
    "message": "แบบทดสอบ"
  },
  "quizzes_7e598f57": {
    "message": "คำถาม"
  },
  "rational_numbers_80ddaa4a": {
    "message": "จำนวนตรรกะ"
  },
  "real_numbers_7c99df94": {
    "message": "จำนวนจริง"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "ส่วนจริง (ของจำนวนเชิงซ้อน)"
  },
  "record_7c9448b": {
    "message": "บันทึก"
  },
  "record_upload_media_5fdce166": {
    "message": "บันทึก/อัพโหลดสื่อ"
  },
  "recording_98da6bda": {
    "message": "กำลังบันทึก"
  },
  "red_8258edf3": {
    "message": "แดง"
  },
  "relationships_6602af70": {
    "message": "ความสัมพันธ์"
  },
  "religion_icon_246e0be1": {
    "message": "ไอคอนศาสนา"
  },
  "remove_f47dc62a": {
    "message": "ลบ"
  },
  "remove_filename_3ea029f6": {
    "message": "ลบ { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "ลบรูปแบบหัวเรื่อง"
  },
  "remove_link_d1f2f4d0": {
    "message": "ลบลิงค์"
  },
  "replace_all_d3d68b3": {
    "message": "แทนที่ทั้งหมด"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "แทนที่ { findText } ทั้งหมดด้วย { replaceText }"
  },
  "replace_e61834a7": {
    "message": "แทนที่"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "แทนที่ { findText } ด้ววย { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "แทนที่ด้วย"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "แทนที่ { alertFindText } ด้วย { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "แทนที่ { alertFindText } ทั้งหมดด้วย { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "รีเซ็ต"
  },
  "resize_ec83d538": {
    "message": "ปรับขนาด"
  },
  "restore_auto_save_deccd84b": {
    "message": "กู้คืนที่บันทึกอัตโนมัติหรือไม่"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "ผลลัพธ์ { index } จาก { max }"
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Reverse Turnstile (มีเกิดผลลัพธ์)"
  },
  "rho_a0244a36": {
    "message": "โร"
  },
  "rho_variant_415245cd": {
    "message": "โร (ตัวแปร)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Rich Content Editor"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "พื้นที่ Rich Text กด { OSKey }+F8 สำหรับชอร์ตคัท Rich Content Editor"
  },
  "right_71ffdc4d": {
    "message": "ขวา"
  },
  "right_align_39e7a32a": {
    "message": "จัดขวา"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "วงเล็บมุมขวา"
  },
  "right_arrow_35e0eddf": {
    "message": "ลูกศรขวา"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "ลูกศรขวาพร้อมขอเกี่ยว"
  },
  "right_ceiling_839dc744": {
    "message": "บนขวา"
  },
  "right_curly_brace_5159d5cd": {
    "message": "ปีกกาขวา"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "ลูกศรฉมวกล่างขวา"
  },
  "right_floor_5392d5cf": {
    "message": "ล่างขวา"
  },
  "right_to_left_9cfb092a": {
    "message": "ขวาไปซ้าย"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "ลูกศรฉมวกบนขวา"
  },
  "rightward_arrow_32932107": {
    "message": "ลูกศรชี้ขวา"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "สามเหลี่ยมชี้ขวา"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "หมุน -90 องศา"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "หมุน 90 องศา"
  },
  "rotation_9699c538": {
    "message": "หมุนองศา"
  },
  "row_fc0944a7": {
    "message": "แถว"
  },
  "row_group_979f5528": {
    "message": "กลุ่มแถว"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "น่าเสียดาย HTML Editor ที่สวยงามไม่สามารถใช้งานผ่านแป้นพิมพ์ ใช้งาน HTML Editor แบบไม่ปรุงแต่งที่นี่"
  },
  "save_11a80ec3": {
    "message": "บันทึก"
  },
  "save_copy_ca63944e": {
    "message": "บันทึกสำเนา"
  },
  "save_media_cb9e786e": {
    "message": "บันทึกสื่อ"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "ไอคอน Icon Maker ที่บันทึกไว้"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "ตัวอ่านหน้าจอไม่สามารถพิจารณาได้ว่าอะไรที่ปรากฏอยู่ในภาพหากไม่มีข้อความเผื่อเลือก และชื่อไฟล์มักเป็นชุกอักขระที่ไม่มีความหมายเฉพาะประกอบไปด้วยตัวเลขและตัวอักษรที่ไม่เกี่ยวข้องกับบริบทหรือความหมายแฝง"
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "ตัวอ่านหน้าจอไม่สามารถระบุเนื้อหาที่จัดแสดงในภาพหากไม่ีข้อความเผื่อเลือกเพื่อระบุบริบทและความหมายของภาพ ข้อความเผื่อเลือกควรกระชับและเข้าใจได้ง่าย"
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "ตัวอ่านหน้าจอไม่สามารถระบุเนื้อหาที่จัดแสดงในภาพหากไม่ีข้อความเผื่อเลือกเพื่อระบุบริบทและความหมายของภาพ"
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "ตัวอ่านหน้าจอไม่สามารถแปลความหมายตารางโดยไม่มีโครงสร้างที่ถูกต้อง หัวเรื่องตารางระบุทิศทางและขอบเขตของเนื้อหา"
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "ตัวอ่านหน้าจอไม่สามารถแปลความหมายตารางโดยไม่มีโครงสร้างที่ถูกต้อง คำบรรยายตารางระบุบริบทและรายละเอียดทั่วไปเกี่ยวกับตารางดังกล่าว"
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "ตัวอ่านหน้าจอไม่สามารถแปลความหมายตารางโดยไม่มีโครงสร้างที่ถูกต้อง หัวตารางกำหนดทิศทางและภาพรวมของเนื้อหา"
  },
  "script_l_42a7b254": {
    "message": "สคริปต์ L"
  },
  "search_280d00bd": {
    "message": "ค้นหา"
  },
  "select_audio_source_21043cd5": {
    "message": "เลือกแหล่งข้อมูลเสียง"
  },
  "select_crop_shape_d441feeb": {
    "message": "เลือกรูปทรงการครอป"
  },
  "select_language_7c93a900": {
    "message": "เลือกภาษา"
  },
  "select_video_source_1b5c9dbe": {
    "message": "เลือกแหล่งข้อมูลวิดีโอ"
  },
  "selected_274ce24f": {
    "message": "เลือกแล้ว"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "{ linkFileName } ที่เลือก"
  },
  "selection_b52c4c5e": {
    "message": "การเลือกรายการ"
  },
  "set_header_scope_8c548f40": {
    "message": "กำหนดขอบเขตหัวเรื่อง"
  },
  "set_minus_b46e9b88": {
    "message": "กำหนดค่าลบ"
  },
  "set_table_header_cfab13a0": {
    "message": "กำหนดหัวเรื่องตาราง"
  },
  "sharp_music_ab956814": {
    "message": "ชาร์ป (ดนตรี)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+ลูกศร"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O เพื่อเปิด HTML Editor ที่สวยงาม"
  },
  "shortcut_911d6255": {
    "message": "ชอร์ตคัท"
  },
  "show_image_options_1e2ecc6b": {
    "message": "แสดงตัวเลือกสำหรับภาพ"
  },
  "show_link_options_545338fd": {
    "message": "แสดงตัวเลือกสำหรับลิงค์"
  },
  "show_rolling_transcript_c1481744": {
    "message": "แสดงบทอ่านแบบเรียลไทม์"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "แสดงบทพูดแบบเรียลไทม์"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "ผู้ใช้ที่อ่านได้เองจะเรียกดูหน้าเว็บได้อย่างรวดเร็ว ทั้งหัวเรื่องตัวใหญ่และตัวหนา ผู้ใช้ตัวอ่านหน้าจอจะต้องอาศัยหัวเรื่องเพื่อทำความเข้าใจบริบทแวดล้อม หัวเรื่องควรใช้โครงสร้างที่เหมาะสม"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "ผู้ใช้ที่อ่านได้เองจะเรียกดูหน้าเว็บได้อย่างรวดเร็ว ทั้งหัวเรื่องตัวใหญ่และตัวหนา ผู้ใช้ตัวอ่านหน้าจอจะต้องอาศัยหัวเรื่องเพื่อทำความเข้าใจบริบทแวดล้อม หัวเรื่องควรกระชับและอยู่ภายในโครงสร้างที่เหมาะสม"
  },
  "sigma_5c35e553": {
    "message": "ซิกม่า"
  },
  "sigma_variant_8155625": {
    "message": "ซิกม่า (ตัวแปร)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "ภาพสีเดียว"
  },
  "single_color_image_color_95fa9a87": {
    "message": "สีเดี่ยวสำหรับภาพสี"
  },
  "size_b30e1077": {
    "message": "ขนาด"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "ขนาดของไฟล์คำบรรยายจะต้องมากกว่าขนาดสูงสุดที่อนุญาตที่ { max } kb"
  },
  "small_b070434a": {
    "message": "เล็ก"
  },
  "small_width_x_height_px_359acd38": {
    "message": "เล็ก ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "วงกลมทึบ"
  },
  "something_went_wrong_89195131": {
    "message": "มีบางอย่างผิดปกติ"
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "มีบางอย่างผิดพลาดในการใช้งานเว็บแคมของคุณ"
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "มีบางอย่างผิดพลาดและเราไม่รู้ว่าจะแสดงอะไรให้กับคุณ"
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "มีบางอย่างผิดปกติ ตรวจสอบการเชื่อมต่อของคุณ โหลดหน้าเพจใหม่แล้วลองใหม่อีกครั้ง"
  },
  "something_went_wrong_d238c551": {
    "message": "มีบางอย่างผิดปกติ"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "มีบางอย่างผิดพลาดขณะแชร์หน้าจอของคุณ"
  },
  "sort_by_e75f9e3e": {
    "message": "จัดเรียงจาก"
  },
  "spades_suit_b37020c2": {
    "message": "โพธิ์ดำ (ชุด)"
  },
  "square_511eb3b3": {
    "message": "จัตุรัส"
  },
  "square_cap_9ec88646": {
    "message": "Cap สี่เหลี่ยม"
  },
  "square_cup_b0665113": {
    "message": "Cup สี่เหลี่ยม"
  },
  "square_root_e8bcbc60": {
    "message": "รากที่สอง"
  },
  "square_root_symbol_d0898a53": {
    "message": "สัญลักษณ์รากที่สอง"
  },
  "square_subset_17be67cb": {
    "message": "ซับเซ็ตของสแควร์"
  },
  "square_subset_strict_7044e84f": {
    "message": "ซับเซ็ตของสแควร์ (เข้มงวด)"
  },
  "square_superset_3be8dae1": {
    "message": "ซุปเปอร์เซ็ตของสแควร์"
  },
  "square_superset_strict_fa4262e4": {
    "message": "ซุปเปอร์เซ็ตของสแควร์ (เข้มงวด)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "ทำกรอบรายการที่ไม่ได้จัดลำดับ"
  },
  "star_8d156e09": {
    "message": "Star"
  },
  "start_over_f7552aa9": {
    "message": "เริ่มใหม่"
  },
  "start_recording_9a65141a": {
    "message": "เริ่มบันทึก"
  },
  "steel_blue_14296f08": {
    "message": "สตีลบลู"
  },
  "studio_media_options_ee504361": {
    "message": "ตัวเลือกมีเดีย Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "ถาดตัวเลือกมีเดีย Studio"
  },
  "styles_2aa721ef": {
    "message": "รูปแบบ"
  },
  "submit_a3cc6859": {
    "message": "ส่ง"
  },
  "submitting_b90fac62": {
    "message": "กำลังจัดส่ง..."
  },
  "subscript_59744f96": {
    "message": "ตัวห้อย"
  },
  "subset_19c1a92f": {
    "message": "ซับเซ็ต"
  },
  "subset_strict_8d8948d6": {
    "message": "ซับเซ็ต (เข้มงวด)"
  },
  "succeeds_9cc31be9": {
    "message": "สัมฤทธิ์"
  },
  "succeeds_equal_158e8c3a": {
    "message": "สัมฤทธิ์เท่ากับ"
  },
  "sum_b0842d31": {
    "message": "ผลรวม"
  },
  "superscript_8cb349a2": {
    "message": "ตัวยก"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "ตัวยกและตัวห้อย"
  },
  "superset_c4db8a7a": {
    "message": "ซุปเปอร์เซ็ต"
  },
  "superset_strict_c77dd6d2": {
    "message": "ซุปเปอร์เซ็ต (เข้มงวด)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "ประเภทไฟล์ที่รองรับ: SRT หรือ WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "สลับไปที่ HTML Editor ที่สวยงาม"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "สลับไปที่ Raw HTML Editor"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "สลับไปที่ HTML Editor"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "สลับไปที่ Rich Text Editor"
  },
  "syllabus_f191f65b": {
    "message": "หลักสูตร"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "อนุญาตเสียงในระบบ"
  },
  "system_audio_disabled_c177bd13": {
    "message": "ปิดใช้งานเสียงในระบบ"
  },
  "tab_arrows_4cf5abfc": {
    "message": "แท็บ/ลูกศร"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "หัวเรื่องตารางเริ่มต้นด้วย { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "ตารางเริ่มต้นด้วย { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "หัวเรื่องตารางควรระบุขอบเขต"
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "ตารางควรครอบคลุมคำบรรยายระบุเนื้อหาของตาราง"
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "ตารางควรมีหัวเรื่องอย่างน้อยหนึ่งรายการ"
  },
  "tau_880974b7": {
    "message": "เทา"
  },
  "teal_f729a294": {
    "message": "ทีล"
  },
  "text_7f4593da": {
    "message": "ข้อความ"
  },
  "text_background_color_16e61c3f": {
    "message": "สีพื้นหลังข้อความ"
  },
  "text_color_acf75eb6": {
    "message": "สีข้อความ"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "ข้อความยากในการอ่านหากไม่มีความเปรียบต่างที่ชัดเจนระหว่างข้อความและพื้นหลัง โดยเฉพาะสำหรับผู้ที่สายตาไม่ดี"
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "ข้อความที่ใหญ่กว่า 18pt (หรือตัวหนา 14pt) ควรมีระดับความเปรียบต่างขั้นต่ำที่ 3:1"
  },
  "text_optional_384f94f7": {
    "message": "ข้อความ (เผื่อเลือก)"
  },
  "text_position_8df8c162": {
    "message": "ตำแหน่งข้อความ"
  },
  "text_size_887c2f6": {
    "message": "ขนาดข้อความ"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "ข้อความที่เล็กกว่า 18pt (หรือตัวหนา 14pt) ควรมีระดับความเปรียบต่างขั้นต่ำที่ 4.5:1"
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "การแสดงตัวอย่างเอกสารปัจจุบันกำลังประมวลผลอยู่ กรุณาลองใหม่อีกครั้งในภายหลัง"
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "หัวเรื่องแรกในเพจควรเป็น H2"
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "ลดความสูงของพื้นที่ Rich Content แล้ว"
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "เพิ่มความสูงของพื้นที่ Rich Content แล้ว"
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "สื่ออยู่ในโดเมนสาธารณะ"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "สื่อได้รับอนุญาตภายใต้ ใช้งานร่วมกันเพื่อการสร้างสรรค์"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "สื่อมีข้อยกเว้น เช่น การใช้งานอย่างเหมาะสม สิทธิ์ในการเสนอราคา หรืออื่น ๆ ภายใต้กฎหมายลิขสิทธิ์ที่เกี่ยวข้อง"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "HTML Editor ที่สวยงามไม่สามารถใช้งานผ่านแป้นพิมพ์ กด Shift-O เพื่อเปิด HTML Editor แบบไม่ปรุงแต่ง"
  },
  "therefore_d860e024": {
    "message": "ดังนั้น"
  },
  "theta_ce2d2350": {
    "message": "เทตา"
  },
  "theta_variant_fff6da6f": {
    "message": "เทตา (ตัวแปร)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "ลูกศรลงแบบหนา"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "ลูกศรซ้ายแบบหนา"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "ลูกศรซ้ายแบบหนา"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "ลูกศรขวาแบบหนา"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "ลูกศรขวาแบบหนา"
  },
  "thick_upward_arrow_acd20328": {
    "message": "ลูกศรบนแบบหนา"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "เอกสารนี้ไม่สามารถแสดงได้ภายใน Canvas"
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "สมการนี้ไม่สามารถเรนเดอร์ได้ในมุมมองพื้นฐาน"
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "ภาพนี้ปัจจุบันไม่พร้อมใช้งาน"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "วิดีโอนี้อาจแสดงโฆษณาจาก YouTube"
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "แม้ว่าวิดีโอของคุณจะมีชื่อที่ถูกต้องในเบราเซอร์ แต่เราไม่สามารถอัพเดตในฐานข้อมูลได้"
  },
  "thumbnail_e0de666f": {
    "message": "ภาพย่อ"
  },
  "timebar_a4d18443": {
    "message": "แถบเวลา"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "ชื่อปล่อยว่างไม่ได้"
  },
  "title_ee03d132": {
    "message": "ชื่อ"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "ที่จะโพสต์: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "สิ่งที่ต้องทำ: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "สลับกลุ่ม { summary }"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "เปิดปิดคำแนะนำในการใช้เครื่องมือ"
  },
  "tools_2fcf772e": {
    "message": "เครื่องมือ"
  },
  "top_66e0adb6": {
    "message": "บน"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "แผงรายการบทพูดใช้ได้ที่ความกว้างมากกว่า 720px"
  },
  "tray_839df38a": {
    "message": "ถาด"
  },
  "triangle_6072304e": {
    "message": "สามเหลี่ยม"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Turnstile (ผลลัพธ์)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "พิมพ์ Control F9 เพื่อเข้าไปยังตัวเลือกสำหรับภาพ { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "พิมพ์ Control F9 เพื่อเข้าไปยังตัวเลือกสำหรับลิงค์ { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "พิมพ์ Control F9 เพื่อเข้าไปยังตัวเลือกสำหรับตาราง { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "ไม่สามารถพิจารณา url การเลือกทรัพยากรข้อมูล"
  },
  "underline_applied_ae01ec97": {
    "message": "ปรับใช้เส้นใต้แล้ว"
  },
  "underline_removed_3693e17c": {
    "message": "ลบเส้นใต้แล้ว"
  },
  "union_e6b57a53": {
    "message": "ยูเนียน"
  },
  "unpublished_dfd8801": {
    "message": "เลิกเผยแพร่แล้ว"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "การเปลี่ยนแปลงที่ไม่ได้บันทึกไว้จะหายไป"
  },
  "untitled_16aa4f2b": {
    "message": "ไม่มีชื่อ"
  },
  "untitled_efdc2d7d": {
    "message": "ไม่ระบุชื่อ"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "ลูกศรขึ้นและทแยงซ้าย"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "ลูกศรขึ้นและทแยงขวา"
  },
  "up_c553575d": {
    "message": "ขึ้น"
  },
  "updated_link_a827e441": {
    "message": "ลิงค์ที่มีการอัพเดต"
  },
  "upload_document_253f0478": {
    "message": "อัพโหลดเอกสาร"
  },
  "upload_file_fd2361b8": {
    "message": "อัพโหลดไฟล์"
  },
  "upload_image_6120b609": {
    "message": "อัพโหลดภาพ"
  },
  "upload_media_ce31135a": {
    "message": "อัพโหลดสื่อ"
  },
  "upload_record_media_e4207d72": {
    "message": "อัพโหลด/บันทึกสื่อ"
  },
  "uploading_19e8a4e7": {
    "message": "กำลังอัพโหลด"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "รายการจัดลำดับอักษรตัวพิมพ์ใหญ่"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "เดลต้าพิมพ์ใหญ่"
  },
  "uppercase_gamma_86f492e9": {
    "message": "แกมม่าพิมพ์ใหญ่"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "แลมบ์ด้าพิมพ์ใหญ่"
  },
  "uppercase_omega_8aedfa2": {
    "message": "โอเมกาพิมพ์ใหญ่"
  },
  "uppercase_phi_caa36724": {
    "message": "ฟายพิมพ์ใหญ่"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "พายพิมพ์ใหญ่"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi พิมพ์ใหญ่"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "รายการจัดลำดับตัวเลขโรมันพิมพ์ใหญ่"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "ซิกม่าพิมพ์ใหญ่"
  },
  "uppercase_theta_49afc891": {
    "message": "เทตาพิมพ์ใหญ่"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "อัปไซลอนพิมพ์ใหญ่"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi พิมพ์ใหญ่"
  },
  "upsilon_33651634": {
    "message": "อัปไซลอน"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "ลูกศรชี้ขึ้นและลง"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "ลูกศรชี้ขึ้นและลง (หนา)"
  },
  "upward_arrow_9992cb2d": {
    "message": "ลูกศรขึ้น"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "สามเหลี่ยมชี้ขึ้น"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "สิทธิ์การใช้งาน:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "สิทธิ์การใช้งาน (ต้องมี)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "ใช้ปุ่มลูกศรเพื่อไปยังตัวเลือกต่าง ๆ"
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "ใช้ปุ่มลูกศรเพื่อเลือกรูปทรง"
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "ใช้ปุ่มลูกศรเพื่อเลือกขนาด"
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "ใช้ปุ่มลูกศรเพื่อเลือกตำแหน่งข้อความ"
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "ใช้ปุ่มลูกศรเพื่อเลือกขนาดข้อความ"
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "ใช้ปุ่มลูกศรเพื่อเลือกขนาดกรอบ"
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "ใช้โดยโปรแกรมอ่านหน้าจอเพื่อระบุเนื้อหา { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "ใช้โดยโปรแกรมอ่านหน้าจอเพื่อระบุเนื้อหาของภาพ"
  },
  "user_documents_c206e61f": {
    "message": "เอกสารของผู้ใช้"
  },
  "user_files_78e21703": {
    "message": "ไฟล์ของผู้ใช้"
  },
  "user_images_b6490852": {
    "message": "ภาพของผู้ใช้"
  },
  "user_media_14fbf656": {
    "message": "สื่อของผู้ใช้"
  },
  "vector_notation_cf6086ab": {
    "message": "เวคเตอร์ (สัญกรณ์)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "แท่งแนวตั้ง (เซ็ตบอกเงื่อนไข)"
  },
  "vertical_dots_bfb21f14": {
    "message": "จุดแนวดิ่ง"
  },
  "video_options_24ef6e5d": {
    "message": "ตัวเลือกวิดีโอ"
  },
  "video_options_tray_3b9809a5": {
    "message": "ถาดตัวเลือกวิดีโอ"
  },
  "video_player_b371005": {
    "message": "เครื่องเล่นวิดีโอ"
  },
  "video_player_for_9e7d373b": {
    "message": "เครื่องเล่นวิดีโอสำหรับ "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "เครื่องเล่นวิดีโอสำหรับ { title }"
  },
  "video_url_889d3263": {
    "message": "URL วิดีโอ"
  },
  "view_all_e13bf0a6": {
    "message": "ดูทั้งหมด"
  },
  "view_ba339f93": {
    "message": "ดู"
  },
  "view_description_30446afc": {
    "message": "ดูรายละเอียด"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "ดูชอร์ตคัทแป้นพิมพ์"
  },
  "view_title_description_67940918": {
    "message": "ดูรายละเอียด { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "ดูจำนวนคำและอักขระ"
  },
  "viewer_restrictions_e14274c9": {
    "message": "ข้อจำกัดสำหรับผู้ชม"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "เราไม่พบไมโครโฟนที่ใช้การได้ที่เชื่อมต่อกับอุปกรณ์ของคุณ"
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "เราไม่พบเว็บแคมที่ใช้การได้ที่เชื่อมต่อกับอุปกรณ์ของคุณ"
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "เราไม่พบเว็บแคมหรือไมโครโฟนที่ใช้การได้ที่เชื่อมต่อกับอุปกรณ์ของคุณ"
  },
  "webcam_disabled_30c66986": {
    "message": "เว็บแคมปิดใช้งาน"
  },
  "webcam_fe91b20f": {
    "message": "เว็บแคม"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "เว็บเพจควรมี H1 เดียวซึ่งจะใช้อัตโนมัติจาก Title ของเพจ หัวเรื่องแรกในเนื้อหาของคุณควรเป็น H2"
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "เมื่อมีการใช้มาร์กอัพที่กำหนดรูปแบบรายการเป็นแสดงรายการแต่ไม่ได้ระบุความสัมพันธ์ในรายการ ผู้ใช้อาจมีปัญหาในการสืบค้นข้อมูล"
  },
  "white_87fa64fd": {
    "message": "คนผิวขาว"
  },
  "why_523b3d8c": {
    "message": "สาเหตุ"
  },
  "width_492fec76": {
    "message": "ความกว้าง"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "ความกว้างและความสูงต้องเป็นตัวเลข"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki Home"
  },
  "word_count_c77fe3a6": {
    "message": "จำนวนคำ"
  },
  "words_b448b7d5": {
    "message": "Words"
  },
  "wreath_product_200b38ef": {
    "message": "Wreath Product"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "ใช่"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "คุณอยู่ที่จานสี เลื่อนจานสีขึ้น ไปทางซ้าย ลงหรือไปทางขวาโดยใช้ปุ่ม ''W'' ''A'' ''S'' และ ''D'' ตามลำดับ"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "คุณอยู่ที่แถบเลื่อนสี เลื่อนแถบเลื่อนไปทางซ้ายหรือขวาโดยใช้ปุ่ม ''A'' และ ''D'' ตามลำดับ"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "คุณอยู่ในแถบเลื่อนอัลฟ่า เลื่อนแถบเลื่อนไปทางซ้ายหรือขวาโดยใช้ปุ่ม ''A'' และ ''D'' ตามลำดับ"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "คุณมีการเปลี่ยนแปลงที่ไม่ได้บันทึกไว้ในถาด Icon Maker ต้องการดำเนินการต่อโดยไม่บันทึกการเปลี่ยนแปลงเหล่านี้หรือไม่"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "คุณอาจต้องปรับหัวเรื่องเพิ่มเติมเพื่อรักษาโครงสร้างของเพจไว้"
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "คุณไม่สามารถอัพโหลดไฟล์เปล่า"
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "ภาพของคุณถูกบีบอัดสำหรับ Icon Maker ภาพที่มีขนาดเล็กกว่า { size } KB จะไม่ถูกบีบอัด"
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "ไมโครโฟนของคุณถูกบล็อคในค่าปรับตั้งของเบราเซอร์"
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "เว็บแคมและไมโครโฟนของคุณถูกบล็อคในค่าปรับตั้งของเบราเซอร์"
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "เว็บแคมของคุณถูกบล็อคในค่าปรับตั้งของเบราเซอร์"
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "เว็บแคมของคุณอาจใช้งานอยู่"
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL ผนวกกับ YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "ซีตา"
  },
  "zoom_f3e54d69": {
    "message": "ซูม"
  },
  "zoom_in_image_bb97d4f": {
    "message": "ซูมภาพเข้า"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "ซูมภาพออก"
  }
};
formatMessage.addLocale({
  th: locale
});